import {
	createHook,
	type BoundActions,
	type HookFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import { type DocNode } from '@atlaskit/adf-schema';

import type { State } from './State';
import { store } from './store';

export const useDataSculptorModal: HookFunction<
	State,
	BoundActions<
		State,
		{
			openModal: (data: string | DocNode) => ({ setState }: StoreActionApi<State>) => void;
			closeModal: () => ({ setState }: StoreActionApi<State>) => void;
		}
	>,
	void
> = createHook(store);
